import React from 'react';
import BrandclubSideWidget from '../components/BrandclubSideWidget/index.js';

var BrandclubSurveyRewards = function (_a) {
    var brandEntity = _a.brandEntity, LinkComponent = _a.LinkComponent;
    return (React.createElement(BrandclubSideWidget, { leftSideProps: {
            type: 'image',
            imageUrl: "https://media.brandclub.com/brand_custom/".concat(brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.id, "/survey.png"),
            imageLink: { id: '', displayName: '' },
        }, rightSideProps: {
            type: 'text',
            title: 'Make your voice heard',
            subtitle: 'Get paid to share your opinions, such as feedback on new products or packaging—make things you care about better.',
            buttonText: '',
            buttonLink: { id: '', displayName: '' },
        }, LinkComponent: LinkComponent }));
};

export { BrandclubSurveyRewards };
//# sourceMappingURL=index.js.map
